import { render } from "./StockReportDetails.vue?vue&type=template&id=d5444508"
import script from "./StockReportDetails.vue?vue&type=script&lang=js"
export * from "./StockReportDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__